import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

/**
 * Liest Theme-Präferenz aus localStorage oder system preference.
 * Synchronisiert <html class="dark"> und speichert Änderungen.
 */
export function useTheme() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    const stored = localStorage.getItem("strombaron-theme");
    if (stored === "light" || stored === "dark") return stored;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("strombaron-theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  return { theme, toggle };
}

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggle}
      aria-label={isDark ? "Auf hell umschalten" : "Auf dunkel umschalten"}
      data-testid="theme-toggle"
      className={`relative w-8 h-8 rounded-full border border-brand-line bg-brand-surface text-brand-ink flex items-center justify-center hover:border-brand-ink hover:bg-brand-offwhite transition-all active:scale-95 ${className}`}
    >
      <span key={theme} className="theme-icon-in inline-flex">
        {isDark
          ? <Sun className="w-3.5 h-3.5" strokeWidth={2.2} style={{ color: 'var(--brand-green-neon)' }} />
          : <Moon className="w-3.5 h-3.5" strokeWidth={2.2} />}
      </span>
    </button>
  );
}
